import React from "react";
import { Navigate } from "react-router-dom";

const AARPChatBot = () => {
  return <Navigate to="/work/aarp-chatbot" replace />;
};

export default AARPChatBot;
